import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dish-set',
  templateUrl: './dish-set.component.html',
  styleUrls: ['./dish-set.component.css']
})
export class DishSetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
